import { Types } from '../actions/types'
import initialState from '../store/initial.state'

export const configReducer = (state = initialState.configReducer, action) => {
  switch (action.type) {
    case Types.ACTIVE_SETTING_DETAIL_NAVIGATION: {
      let activeSettingsDetailNavigation = action.payload
      return {
        ...state,
        config: {
          ...state.config,
          activeSettingsDetailNavigation: activeSettingsDetailNavigation,
        },
      }
    }
    case Types.IS_NOTIFICATION_ACTIVE: {
      let isNotificationActive = action.payload
      return {
        ...state,
        config: {
          ...state.config,
          isNotificationActive: isNotificationActive,
        },
      }
    }

    default:
      return state
  }
}
